import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  isSubmitting = signal(false);
  logoutMessage = signal(''); // Message to display when user is logged out

  constructor(
    private readonly router: Router, 
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Check if there's a logout message in query params
    this.route.queryParams.subscribe(params => {
      if (params['message']) {
        this.logoutMessage.set(params['message']);
        // Clear the message after 5 seconds
        setTimeout(() => {
          this.logoutMessage.set('');
        }, 5000);
      }
    });
  }

  async onProceedToSSO(): Promise<void> {
    this.isSubmitting.set(true);
    
    try {
      console.log('✅ Routing to SSO');
      await this.router.navigateByUrl('/sso');
    } catch (e: any) {
      console.warn('❌ Error routing to SSO:', e);
    } finally {
      this.isSubmitting.set(false);
    }
  }

}


